import { MinimumOrderQuantityType } from '../constant';

export function useMinimumOrderQuantityToastMessage(
  minimum_order_quantity_type: string | null,
  minimum_order_quantity: number,
) {
  let message = '';

  switch (minimum_order_quantity_type) {
    case MinimumOrderQuantityType.PRODUCT:
      message = `${minimum_order_quantity}개부터 구매 가능합니다.`;
      break;

    case MinimumOrderQuantityType.ITEM:
      message = `옵션별 ${minimum_order_quantity}개부터 구매 가능합니다.`;
      break;
  }
  return message;
}
